import script from "./loginCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./loginCode.vue?vue&type=script&setup=true&lang=ts"

import "./loginCode.vue?vue&type=style&index=0&id=1d93da5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d93da5c"]])

export default __exports__